import { Link } from "react-router-dom";
import { useLang } from "./lang";
import { company, credits } from "./data";
import { links } from "./navigationBar";

function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-ink text-steel-100">
      <div className="wrap grid gap-10 py-14 md:grid-cols-[2fr_1fr_1fr]">
        <div>
          <img src="/logo192.png" alt="GWS" width="56" height="56" className="mb-4 h-14 w-14 rounded bg-white p-1" />
          <p className="text-lg font-semibold text-white">{t(company.name)}</p>
          <p className="mt-2 max-w-md text-steel-200">{t(company.address)}</p>
        </div>
        <div>
          <p className="mb-3 font-semibold text-white">{t("ติดต่อ", "Contact")}</p>
          <ul className="space-y-2">
            <li><a className="hover:text-safety" href={`tel:${company.tel}`}>{company.phone}</a></li>
            <li><a className="break-all hover:text-safety" href={`mailto:${company.email}`}>{company.email}</a></li>
            <li><a className="hover:text-safety" href={company.facebook} target="_blank" rel="noreferrer">Facebook</a></li>
          </ul>
        </div>
        <div>
          <p className="mb-3 font-semibold text-white">{t("เมนู", "Pages")}</p>
          <ul className="space-y-2">
            {links.map(([to, th, en]) => (
              <li key={to}><Link className="hover:text-safety" to={to}>{t(th, en)}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="wrap space-y-2 py-6 text-xs text-steel-400">
          <p>© {new Date().getFullYear()} gws-rd.com</p>
          <details>
            <summary className="cursor-pointer">{t("เครดิตภาพตัวอย่าง (Wikimedia Commons)", "Sample photo credits (Wikimedia Commons)")}</summary>
            <ul className="mt-2 space-y-1">
              {credits.map(([id, c]) => <li key={id}>{c}</li>)}
            </ul>
          </details>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
